import { Injectable, Injector } from '@angular/core';
import { AbstractGitFactoryService } from '@y42/feature/git/state';
import { VisualizationTabGitService } from './visualization-tab-git.service';

@Injectable({ providedIn: 'root' })
export class VisualizationTabGitFactoryService extends AbstractGitFactoryService<VisualizationTabGitService> {
  constructor(injector: Injector) {
    super({
      injector,
      gitService: VisualizationTabGitService,
    });
  }
}
